import Types from '../modules/types';

const {
  CONSTANTS: {
    StoreType,
  },
} = Types;

const tests = Types.ROLE.reduce(
  (agr, role) => {
    ['===', '!=='].forEach(op => ['user', 'viewer'].forEach((type) => {
      agr[`${
        type
      }${
        op === '===' ? 'Is' : 'IsNot'
      }${
        role[0]
      }${
        role.slice(1).toLowerCase()
      }`] = (
          type === 'user'
        ? (props) => {
            let value = null;
            if (props.form) {
              value = props.form.getFieldValue('role');
            }
            if (!value && props.data) {
              value = props.data.role;
            }
            return op === '==='
            ? value === role
            : value !== role;
          }
        : [
            'condition.checkViewer',
            'role',
            op,
            role,
          ]
      );
    }));
    return agr;
  },
  {},
);

tests.activityIsNotCreate = ({ activity }) => activity !== 'create';
tests.activityIsNotEdit = ({ activity }) => activity !== 'edit';

tests.activityIsNotEdit = ({ activity }) => activity !== 'edit';

tests.viewerIsSellerMerchant = [
  'condition.checkViewer',
  'storeType',
  '===',
  StoreType.MERCHANT,
];

tests.viewerIsSellerReferral = [
  'condition.checkViewer',
  'storeType',
  '===',
  StoreType.REFERRAL,
];

tests.viewerIsUserOwner = props => (
     props.data
  && props.viewer
  && props.data._id === props.viewer._id
);

tests.viewerIsNotUserOwner = [
  'condition.not',
  tests.viewerIsUserOwner,
];

tests.viewerIsNotAdminWithEmail = (emails = []) => props => (
      props.viewer?.role !== 'ADMIN'
  || !emails.includes(props.viewer?.email)
);

tests.viewerIsNotAdminWithEmail.THEHIVERS_EMAILS = [
  'nikolakanacki@thehive.rs',
  'markoradak@thehive.rs',
  'ivanprtljaga@thehive.rs',
  'katarinasava@thehive.rs',
];

tests.viewerIsNotAdminWithEmail.PACKMAN_C_SUITE_EMAILS = [
  'abdulaziz@packman.app',
  'mohamed@packman.app',
  'saleh@packman.app',
];

tests.viewerIsNotThehiveRsAdmin = tests.viewerIsNotAdminWithEmail([
  ...tests.viewerIsNotAdminWithEmail.THEHIVERS_EMAILS,
]);

tests.viewerIsNotThehiveRsAdminNorAbdul = tests.viewerIsNotAdminWithEmail([
  ...tests.viewerIsNotAdminWithEmail.THEHIVERS_EMAILS,
  'abdulaziz@packman.app',
  'saleh@packman.app',
]);

tests.viewerIsNotThehiveRsAdminNorTheexampleshopSeller = [
  'condition.and',
  [
    tests.viewerIsNotThehiveRsAdmin,
    props => (
      props.viewer?.role !== 'SELLER'
      || props.viewer?.storeData?.slug !== 'example'
    ),
  ],
];

tests.viewerIsAdminAndDoesNotHavePermission = (key) => props => (
  props.viewer?.role === 'ADMIN'
  && ![
    ...tests.viewerIsNotAdminWithEmail.THEHIVERS_EMAILS,
    ...tests.viewerIsNotAdminWithEmail.PACKMAN_C_SUITE_EMAILS,
  ].includes(props.viewer?.email)
  && !props?.viewer?.permissions[key]?.includes(props.viewer._id)
)

tests.viewerIsAdminAndDoesNotHavePermissionToEditProducts = (key) => props => {
  let isValid = false;
  if (props.data?.storeData) {
    // eslint-disable-next-line max-len
    const { supported, storage } = props.data?.storeData?.shipping?.PACKMAN_SHOP;
    const supportWH = supported === true && storage === 'WAREHOUSE';
    if (props.viewer?.role === 'ADMIN') {
      // return false = dont skip
      // eslint-disable-next-line max-len
      isValid = supportWH ? ![...props?.viewer?.permissions.forceProductsEditAndDeletion]?.includes(props.viewer._id) : false;
    } else {
        // eslint-disable-next-line max-len
       isValid = supportWH ? props.viewer?.store !== '66ee76392436f1003d3022fd' ? true : false : false;
    }
  }
  return isValid;
}

 // eslint-disable-next-line max-len
tests.viewerIsAdminAndDoesNotHavePermissionToEditProductsOtherCases = props => {
  let isValid = false;
  if (props?.datas[0]?.storeData) {
    // eslint-disable-next-line max-len
    const { supported, storage } = props?.datas[0]?.storeData?.shipping?.PACKMAN_SHOP;
    const supportWH = supported === true && storage === 'WAREHOUSE';
    if (props.viewer?.role === 'ADMIN') {
      // return false = dont skip
      // eslint-disable-next-line max-len
      isValid = supportWH ? !props?.viewer?.permissions.forceProductsEditAndDeletion?.includes(props.viewer._id) : false;
    } else {
      isValid = supportWH ? true : false;
    }
  }
  return isValid;
}
// eslint-disable-next-line max-len
tests.viewerIsAdminAndDoesNotHavePermissionToEditProductsOtherCasesReversed = props => {
  let isValid = false;
  if (props?.datas[0]?.storeData) {
    // eslint-disable-next-line max-len
    const { supported, storage } = props?.datas[0]?.storeData?.shipping?.PACKMAN_SHOP;
    const supportWH = supported === true && storage === 'WAREHOUSE';
    if (props.viewer?.role === 'ADMIN') {
      // return false = dont skip
      // eslint-disable-next-line max-len
      isValid = supportWH ? !props?.viewer?.permissions.forceProductsEditAndDeletion?.includes(props.viewer._id) : false;
    } else {
      isValid = supportWH ? true : false;
    }
  }
  return !isValid;
}

tests.getLatestPaymentStatus = (payment) => {
  if (payment?.refunded) return 'refunded';
  if (payment?.voided) return 'voided';
  if (payment?.authorized) return 'authorized';
  if (payment?.captured) return 'captured';
  return 'unknown'; // Default case if no known statuses match
}

tests.toCapitalized = (str) => (
  str ? str.charAt(0).toUpperCase() + str.slice(1).toLowerCase() : ''
)

export default tests;
